import { render, staticRenderFns } from "./AddtoJDModal.vue?vue&type=template&id=a92fb126&scoped=true&"
import script from "./AddtoJDModal.vue?vue&type=script&lang=js&"
export * from "./AddtoJDModal.vue?vue&type=script&lang=js&"
import style0 from "./AddtoJDModal.vue?vue&type=style&index=0&id=a92fb126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92fb126",
  null
  
)

export default component.exports